<!--
 * @Description: 网银支付信息配置
 * @Date: 2025-09-11 16:14:35
-->
<template>
  <BaseDialog
    width="450px"
    title="网银支付结算单支付信息配置"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
  >
    <BaseTextContent style="height: 446px">
      <BaseForm ref="formRef" label-position="right" :model="formData">
        <BaseFormItem
          label="单位名称"
          prop="companyName"
          :rules="[
            {
              required: true,
              message: '请输入单位名称',
              trigger: 'change'
            }
          ]"
        >
          <BaseInput
            style="width: 100%"
            type="text"
            placeholder="请输入"
            disabled
            v-model="formData.companyName"
          />
        </BaseFormItem>
        <BaseFormItem
          label="开户银行"
          prop="bankName"
          :rules="[
            {
              required: true,
              message: '请输入开户银行',
              trigger: 'change'
            }
          ]"
        >
          <BaseInput
            style="width: 100%"
            type="text"
            placeholder="请输入"
            max-length="30"
            v-model="formData.bankName"
          />
        </BaseFormItem>
        <BaseFormItem
          label="银行账号"
          prop="bankNumber"
          :rules="[
            {
              required: true,
              message: '请输入银行账号',
              trigger: 'change'
            }
          ]"
        >
          <BaseInput
            style="width: 100%"
            type="text"
            placeholder="请输入"
            max-length="30"
            v-model="formData.bankNumber"
          />
        </BaseFormItem>
      </BaseForm>
    </BaseTextContent>
    <template #footer>
      <BaseButton type="default" @click="onCancel">取消</BaseButton>
      <BaseButton type="primary" :click="onConfirm">保存</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="ts" setup>
import { ref, defineEmits, withDefaults, defineProps, onMounted } from 'vue';
import {
  BaseForm,
  BaseButton,
  XrkMessage,
  BaseDialog,
  BaseFormItem,
  BaseInput
} from 'xrk-components';
import {
  getEnterpriseCupBankInfo,
  saveEnterpriseCupBankInfo
} from '../data-source/apis';
import { GetEnterpriseCupBankInfoData } from '../data-source/types';
import { BaseTextContent } from 'xrk-components';

const emits = defineEmits(['success']);
const props = withDefaults(
  defineProps<{
    remove?: () => {};
    deptId: number;
    entpName: string;
  }>(),
  {}
);

const formRef = ref();
const formData = ref<GetEnterpriseCupBankInfoData>({
  deptId: props.deptId,
  companyName: props.entpName,
  cupBankId: null,
  bankName: '',
  bankNumber: '',
  companyCardNo: ''
});

const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  await formRef.value.validate();
  await saveEnterpriseCupBankInfo(formData.value);
  XrkMessage.success('操作成功');
  emits('success');
  onCancel();
};

onMounted(async () => {
  const { data } = await getEnterpriseCupBankInfo({
    deptId: props.deptId
  });
  Object.assign(formData.value, data ?? {});
});
</script>
<style lang="scss"></style>
